// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


let base_url: string = 'https://imake-app.com';

export const environment = {
  production: true,
  graphqlendpoint: `${base_url}:1114/graphql`,
  ApiEndPoint: `${base_url}:1114/api`,
  ApiEndPoint2: `${base_url}:1116/api`,
  PaymentApiEndPoint: `${base_url}:5111/api`,
  PaymentApiEndPointGraphql: `${base_url}:5111/graphql`,

  products: 'http://backend.backend.satamall.satatechnologygroup.net:4200/products',
  google_api_key : "AIzaSyD_U2-w1Zald01AAXfi4vO6EH35YYc0-hM",
  paymob_accept_base_url: 'https://accept.paymob.com/api',
  paymob_api_key:
  'ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6VXhNaUo5LmV5SmpiR0Z6Y3lJNklrMWxjbU5vWVc1MElpd2ljSEp2Wm1sc1pWOXdheUk2TVRneU16QTVMQ0p1WVcxbElqb2lhVzVwZEdsaGJDSjkuSnFldzRhSTZNOVlfRnRpOHJXdGdIR3JuNXEwbVVWSW16VGZmRUVYWVZMNnBEMFJiOXZyRWI2Uy16MTliSnMxdXkwYm8wNlAyb1dTellmTHp4Mk1HekE=',
  integrationId: '3080146',
  iframeId: '388966',
  gaTRACKING:'null'
  ,
  vendor_code:'Ar9dlPghiF1332023'
  ,
  vendor_id:'457'
  ,
  site_name:'Eshop - Online Shopping, Fashion, Electronics, Beauty, Groceries'
  ,
  currency: ''

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
